import styled from 'styled-components';

const vipCard = styled.div`
  .detail-label {
    height: 18px;
    font-size: 14px;
    font-weight: 400;
    color: #a8a8a8;
    line-height: 21px;
  }
  .detail-info {
    height: 20px;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    line-height: 24px;
    margin-top: 16px;
  }
  .detail-title {
    margin-bottom: 24px;
    height: 28px;
    font-size: 18px;
    font-weight: 500;
    color: #212121;
    line-height: 27px;
  }
`;
export default vipCard;
